/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { UserDTO } from "./user-dto";

export class User {

    public static readonly DEFAULT = new User(
        '0', 
        'username', 
        'name', 
        'surname', 
        'email', 
        false
    );

    public ID: string;
    public username: string;
    public name: string;
    public surname: string;
    public email: string;
    public emailVerified: boolean;

    constructor(
        ID: string, 
        username: string,
        name: string,
        surname: string,
        email: string,
        emailVerified: boolean
    ) {
        this.ID = ID;
        this.username = username;
        this.name = name;
        this.surname = surname;
        this.email = email;
        this.emailVerified = emailVerified;
    }

    public static createFromDTO(userDTO: UserDTO): User {
        return new User(
            userDTO.ID, 
            userDTO.username,
            userDTO.name,
            userDTO.surname,
            userDTO.email,
            userDTO.emailVerified
        );
    }

}